export default __webpack_public_path__ + "static/media/instagram-logo.f4cf7baa.svg";